import { Injectable } from "@angular/core";
import { PurchaseOrder } from "../models/purchase-order";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class MailerService {
  constructor(private http:HttpClient) { }

  postOrder(order:PurchaseOrder, email): Promise<void>{
    return this.http.post<void>(`/api/purchases/order/${order.id}/email`, {email})
        .toPromise();
  }

}